import {
  Navigate,
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom';
import ProtectedLayout from "./ProtectedLayout";
import SignUp from '@/containers/Pages/SignUp/SignUp';
import ForgotPassword from '@/containers/Pages/ForgotPassword/ForgotPassword';
import ResetPassword from '@/containers/Pages/ResetPassword/ResetPassword';
import Dashboard from '@/containers/Dashboard/Dashboard';
import Docs from '@/containers/Docs/Docs';
import Webhook from '@/containers/Docs/Webhook';
import TransactionsDetail from '@/containers/Transactions/TransactionsDetail';
import Transactions from '@/containers/Transactions/Transactions';
import Settings from '@/containers/Settings/Settings';
import SettingsIntegration from '@/containers/Settings/Integration';
import FAQ from '@/containers/FAQ/faq';
import MyAccount from '@/containers/MyAccount/MyAccount';
import PaymentResult from '@/containers/MyAccount/PaymentResult';
import AuthLayout from './AuthLayout';
import { HasPermission } from '@/helpers/permission';
import EmailConfirmation from '@/containers/Pages/EmailConfirmation/EmailConfirmation';
import SignIn from '@/containers/Pages/SignIn/SignIn';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<SignIn />} />
        <Route path="/register" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/confirm-email/:email" element={<EmailConfirmation />} />
      </Route>

      <Route path="docs">
        <Route path="integration" element={<Docs />} />
        <Route path="webhook" element={<Webhook />} />
      </Route>
      <Route path="/faq" element={<FAQ />} />

      <Route element={<ProtectedLayout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        {HasPermission("view_transaction") && (
          <Route path="/transactions/:id" element={<TransactionsDetail />} />
        )}
        {HasPermission("list_transactions") && (
          <Route path="/transactions" element={<Transactions />} />
        )}
        <Route path="settings">
          <Route path="capture" element={<Settings />} />
          <Route path="integration" element={<SettingsIntegration />} />
        </Route>
        <Route path="/my-account" element={<MyAccount />}>
          <Route path=":tab" element={<MyAccount />}>
            <Route path=":tab" element={<MyAccount />} />
          </Route>
        </Route>
        <Route
          path="/my-account/financial/checkout"
          element={<PaymentResult />}
        />
      </Route>
      <Route path="*" element={<Navigate to={"/login"} replace />} />
    </>
  ),
);
